import * as Types from '../../../../@graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type TopIncutBlockByIdQueryVariables = Types.Exact<{
  blockId: Types.Scalars['UUID'];
}>;


export type TopIncutBlockByIdQuery = (
  { __typename?: 'Query' }
  & { topIncutBlockById?: Types.Maybe<(
    { __typename?: 'TopIncutBlock' }
    & TopIncutBlockByIdFragmentFragment
  )> }
);

export type SaveTopIncutBlockByIdMutationVariables = Types.Exact<{
  data: Types.SaveTopIncutBlockInput;
}>;


export type SaveTopIncutBlockByIdMutation = (
  { __typename?: 'Mutation' }
  & { saveTopIncutBlock?: Types.Maybe<(
    { __typename?: 'SaveTopIncutBlockPayload' }
    & { block?: Types.Maybe<(
      { __typename?: 'TopIncutBlock' }
      & TopIncutBlockByIdFragmentFragment
    )> }
  )> }
);

export type TopIncutBlockByIdFragmentFragment = (
  { __typename?: 'TopIncutBlock' }
  & Pick<Types.TopIncutBlock, 'uid' | 'position' | 'title' | 'incutType' | 'url' | 'clickCount'>
  & { figureVersion?: Types.Maybe<(
    { __typename?: 'FigureVersion' }
    & Pick<Types.FigureVersion, 'id'>
    & { figure: (
      { __typename?: 'Figure' }
      & Pick<Types.Figure, 'id' | 'uid' | 'src'>
      & { cropperPreview: (
        { __typename?: 'Image' }
        & Pick<Types.Image, 'url'>
      ) }
    ), crop: (
      { __typename?: 'Crop' }
      & Pick<Types.Crop, 'height' | 'left' | 'top' | 'width'>
    ), primaryProcessedImage?: Types.Maybe<(
      { __typename?: 'Image' }
      & Pick<Types.Image, 'url'>
    )> }
  )> }
);

export const TopIncutBlockByIdFragmentFragmentDoc = gql`
    fragment TopIncutBlockByIdFragment on TopIncutBlock {
  uid
  position
  title
  incutType
  url
  clickCount
  figureVersion {
    figure {
      id
      uid
      cropperPreview {
        url
      }
      src
    }
    id
    crop {
      height
      left
      top
      width
    }
    primaryProcessedImage {
      url
    }
  }
}
    `;
export const TopIncutBlockByIdDocument = gql`
    query topIncutBlockById($blockId: UUID!) {
  topIncutBlockById(blockId: $blockId) {
    ...TopIncutBlockByIdFragment
  }
}
    ${TopIncutBlockByIdFragmentFragmentDoc}`;

/**
 * __useTopIncutBlockByIdQuery__
 *
 * To run a query within a React component, call `useTopIncutBlockByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopIncutBlockByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopIncutBlockByIdQuery({
 *   variables: {
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useTopIncutBlockByIdQuery(baseOptions: Apollo.QueryHookOptions<TopIncutBlockByIdQuery, TopIncutBlockByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopIncutBlockByIdQuery, TopIncutBlockByIdQueryVariables>(TopIncutBlockByIdDocument, options);
      }
export function useTopIncutBlockByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopIncutBlockByIdQuery, TopIncutBlockByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopIncutBlockByIdQuery, TopIncutBlockByIdQueryVariables>(TopIncutBlockByIdDocument, options);
        }
export type TopIncutBlockByIdQueryHookResult = ReturnType<typeof useTopIncutBlockByIdQuery>;
export type TopIncutBlockByIdLazyQueryHookResult = ReturnType<typeof useTopIncutBlockByIdLazyQuery>;
export type TopIncutBlockByIdQueryResult = Apollo.QueryResult<TopIncutBlockByIdQuery, TopIncutBlockByIdQueryVariables>;
export const SaveTopIncutBlockByIdDocument = gql`
    mutation saveTopIncutBlockById($data: SaveTopIncutBlockInput!) {
  saveTopIncutBlock(data: $data) {
    block {
      ...TopIncutBlockByIdFragment
    }
  }
}
    ${TopIncutBlockByIdFragmentFragmentDoc}`;
export type SaveTopIncutBlockByIdMutationFn = Apollo.MutationFunction<SaveTopIncutBlockByIdMutation, SaveTopIncutBlockByIdMutationVariables>;

/**
 * __useSaveTopIncutBlockByIdMutation__
 *
 * To run a mutation, you first call `useSaveTopIncutBlockByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTopIncutBlockByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTopIncutBlockByIdMutation, { data, loading, error }] = useSaveTopIncutBlockByIdMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveTopIncutBlockByIdMutation(baseOptions?: Apollo.MutationHookOptions<SaveTopIncutBlockByIdMutation, SaveTopIncutBlockByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTopIncutBlockByIdMutation, SaveTopIncutBlockByIdMutationVariables>(SaveTopIncutBlockByIdDocument, options);
      }
export type SaveTopIncutBlockByIdMutationHookResult = ReturnType<typeof useSaveTopIncutBlockByIdMutation>;
export type SaveTopIncutBlockByIdMutationResult = Apollo.MutationResult<SaveTopIncutBlockByIdMutation>;
export type SaveTopIncutBlockByIdMutationOptions = Apollo.BaseMutationOptions<SaveTopIncutBlockByIdMutation, SaveTopIncutBlockByIdMutationVariables>;